var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('month-picker',{on:{"periodo":_vm.onPeriodoChange},model:{value:(_vm.periodo),callback:function ($$v) {_vm.periodo=$$v},expression:"periodo"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }